var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrassRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 131,
    viewBox: "0 0 237 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 126.82C140 126.82 145.156 95.9719 156.931 52.7168L161.636 54.8075C161.636 54.8075 152.709 86.1064 150.422 104.736C150.422 104.736 158.015 78.5196 164.976 60.9171L177.293 68.6667C177.293 68.6667 171.726 96.9234 168.075 119.308L169.831 119.396L181.275 61.3303L184.285 61.7809C184.285 61.7809 179.43 91.0016 176.441 125.318L184.465 125.994L189.48 100.116L194.245 100.329L191.125 127.221L194.476 127.371C194.476 127.371 201.848 71.3333 208.227 50L219 50.4757C219 50.4757 213.684 95.9718 211.206 130L140 126.82Z",
    fill: "url(#paint0_linear_159_1968)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213 129.864C215.463 103.81 220.824 78.2875 228.937 54L233 54.1734C233 54.1734 221.41 84.3554 216.332 130L213 129.864Z",
    fill: "url(#paint1_linear_159_1968)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 126.641C139 126.641 143.319 90.9428 147.905 63L156 63.3711C151.633 84.2414 148.497 105.512 146.618 127L139 126.641Z",
    fill: "url(#paint2_linear_159_1968)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102 95.6048C102 95.6048 102.23 78.1229 103.14 64.959L105.059 65.0257C105.059 65.0257 103.68 79.6003 103.91 95.662L102 95.6048Z",
    fill: "url(#paint3_linear_159_1968)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.787 96.1675C117.787 96.1675 121.147 80.0677 128.626 67.085L135.124 67.3042C135.124 67.3042 128.196 78.6379 124.286 96.3868L117.787 96.1675Z",
    fill: "url(#paint4_linear_159_1968)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.541 97.3875C154.541 97.3875 162.16 67.3612 173.118 48.6592L180.307 50.3273C180.307 50.3273 171.168 74.1005 166.529 97.7879L154.541 97.3875Z",
    fill: "url(#paint5_linear_159_1968)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222 130.699C222 130.699 225.103 105.336 232.345 86L237 86.2005C232.572 100.602 229.822 115.68 228.828 131L222 130.699Z",
    fill: "url(#paint6_linear_159_1968)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 104.899C42 104.899 46.5292 77.3896 51.3384 55.8564L59.827 56.1424C55.2481 72.2253 51.9591 88.6171 49.9887 105.176L42 104.899Z",
    fill: "url(#paint7_linear_159_1968)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 123.872C38 123.872 43.1557 74.1296 54.9314 4.38084L59.6357 7.75216C59.6357 7.75216 50.7086 58.2216 48.4216 88.2611C48.4216 88.2611 56.0147 45.9878 62.9759 17.6038L75.2933 30.1001C75.2933 30.1001 69.7264 75.6639 66.0753 111.76L67.8306 111.901L79.2754 18.27L82.2845 18.9968C82.2845 18.9968 77.4298 66.1151 74.4407 121.45L82.4651 122.54L87.4803 80.8118L92.2448 81.1549L89.1253 124.518L92.4755 124.761C92.4755 124.761 99.8479 34.4 106.227 0L117 0.767146C117 0.767146 111.684 74.1296 109.206 129L38 123.872Z",
    fill: "url(#paint8_linear_159_1968)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 129.778C113.463 87.2692 118.824 45.627 126.937 6L131 6.28292C131 6.28292 119.41 55.5272 114.332 130L111 129.778Z",
    fill: "url(#paint9_linear_159_1968)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 123.417C37 123.417 41.3191 65.407 45.9052 20L54 20.603C49.6335 54.5172 46.4971 89.0826 44.6181 124L37 123.417Z",
    fill: "url(#paint10_linear_159_1968)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 120.879C0 120.879 0.225491 83.8687 1.11765 56L3 56.1413C3 56.1413 1.64706 86.9965 1.87255 121L0 120.879Z",
    fill: "url(#paint11_linear_159_1968)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 122.536C16 122.536 19.2941 88.4704 26.6274 61L33 61.4639C33 61.4639 26.2059 85.445 22.3726 123L16 122.536Z",
    fill: "url(#paint12_linear_159_1968)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 125.153C53 125.153 60.3923 61.5902 71.0248 22L78 25.5312C78 25.5312 69.1331 75.8565 64.6317 126L53 125.153Z",
    fill: "url(#paint13_linear_159_1968)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 130.512C120 130.512 123.103 89.3671 130.345 58L135 58.3252C130.572 81.687 127.822 106.147 126.828 131L120 130.512Z",
    fill: "url(#paint14_linear_159_1968)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_1968",
    x1: 178.341,
    y1: 128.488,
    x2: 181.884,
    y2: 48.7955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_1968",
    x1: 221.874,
    y1: 130.21,
    x2: 225.193,
    y2: 53.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_1968",
    x1: 146.613,
    y1: 126.955,
    x2: 149.566,
    y2: 63.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_159_1968",
    x1: 102.852,
    y1: 95.602,
    x2: 103.892,
    y2: 64.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_159_1968",
    x1: 125.933,
    y1: 96.3861,
    x2: 126.932,
    y2: 66.9757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_159_1968",
    x1: 166.521,
    y1: 97.7643,
    x2: 168.195,
    y2: 48.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_159_1968",
    x1: 228.83,
    y1: 130.957,
    x2: 230.773,
    y2: 85.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_159_1968",
    x1: 49.983,
    y1: 105.141,
    x2: 51.657,
    y2: 55.8471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_159_1968",
    x1: 76.3405,
    y1: 126.562,
    x2: 85.524,
    y2: -1.53797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_159_1968",
    x1: 119.874,
    y1: 130.343,
    x2: 128.683,
    y2: 6.08006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_159_1968",
    x1: 44.6127,
    y1: 123.926,
    x2: 52.3835,
    y2: 20.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_159_1968",
    x1: 0.835335,
    y1: 120.873,
    x2: 5.5712,
    y2: 56.2799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_159_1968",
    x1: 23.9876,
    y1: 122.999,
    x2: 28.5287,
    y2: 61.0298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_159_1968",
    x1: 64.6236,
    y1: 125.95,
    x2: 72.3215,
    y2: 22.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_159_1968",
    x1: 126.83,
    y1: 130.93,
    x2: 131.929,
    y2: 58.0778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B7AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABE400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassRight);
export default __webpack_public_path__ + "static/media/grassRight.e1b9f5f88a6052fa29c95620a2b05403.svg";
export { ForwardRef as ReactComponent };